import Vue from 'vue'
import Vuetify from 'vuetify'
import pt from 'vuetify/src/locale/pt'
import theme from '@/styles/Theme'
import getCspNonce from '@/utils/cspNonce'

import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

import SlaIcon from '@/utils/SlaIcon.vue'
import FinxIcon from '../utils/FinxIcon.vue'
import HisIcon from '../utils/HisIcon.vue'

Vue.use(Vuetify, {
  iconfont: 'mdi',
  theme,
  options: {
    // Nonce da CSP para a folha de estilo de tema injetada pelo Vuetify
    cspNonce: getCspNonce(),
  },
  lang: {
    locales: {
      pt,
    },
    current: 'pt',
  },
  icons: {
    finx: {
      component: FinxIcon,
    },
    his: {
      component: HisIcon,
    },
    sla: {
      component: SlaIcon,
    },
  },
})
